import type NumberUnit from '@exodus/currency';
import type { Quote } from '@exodus/fiat-ramp/api';

import type { Asset } from '@/types';
import Hero from './hero.js';
import ToToken from './to-token.js';

type FiatFormProps = {
  fiatAmount: NumberUnit;
  cryptoAmount: NumberUnit;
  cryptoAsset: Asset;
  quote?: Quote;
  loading: boolean;
  onTokenSelect: () => void;
  onAmountChange: (value: NumberUnit) => void;
};

function FiatForm({
  fiatAmount,
  cryptoAmount,
  cryptoAsset,
  quote,
  loading,
  onTokenSelect,
  onAmountChange,
}: FiatFormProps) {
  return (
    <>
      <Hero amount={fiatAmount} onAmountChange={onAmountChange} />

      <ToToken
        amount={cryptoAmount}
        token={cryptoAsset}
        fee={quote?.networkFee}
        loading={loading}
        onTokenSelect={onTokenSelect}
      />
    </>
  );
}

export default FiatForm;
